import SteveSchema from '../steve-schema';

/**
 * This is the steve schema that's used for the cluster store
 */
export default class ClusterStoreSchema extends SteveSchema { }
